/**
 * `ui/index.js`
 *  -  プロジェクトのUI関係を統合
 *
 * 使用方法:
 *  - import {initUi} from "./ui/index.js";
 */


import {initGlobalNavi} from "./globalNavi.js";
import {initMenu} from "./menu.js";

export const initUi = async () => {
  console.log("🎨 Initializing Ui Modules...");
  initGlobalNavi();
  initMenu();
};